// Phase 3 — maps NavigationRegistry's logical `icon` strings to MUI icon
// components. Keeping this mapping out of NavigationRegistry keeps the
// registry framework-agnostic (per Step 7.5: "Navigation must not contain
// business logic" / rendering decisions).

import HomeIcon from "@mui/icons-material/Home";
import ChurchIcon from "@mui/icons-material/Church";
import ListAltIcon from "@mui/icons-material/ListAlt";
import PeopleIcon from "@mui/icons-material/People";
import GroupsIcon from "@mui/icons-material/Groups";
import SearchIcon from "@mui/icons-material/Search";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MessageIcon from "@mui/icons-material/Message";
import SettingsIcon from "@mui/icons-material/Settings";
import ArticleIcon from "@mui/icons-material/Article";
import LabelIcon from "@mui/icons-material/Label";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import RedeemIcon from "@mui/icons-material/Redeem";
import DashboardCustomizeOutlinedIcon from "@mui/icons-material/DashboardCustomizeOutlined";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import HandshakeIcon from "@mui/icons-material/Handshake";
import InsightsIcon from "@mui/icons-material/Insights";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import EventIcon from "@mui/icons-material/Event";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import MailIcon from "@mui/icons-material/Mail";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import CampaignIcon from "@mui/icons-material/Campaign";
import SendIcon from "@mui/icons-material/Send";
import PaymentsIcon from "@mui/icons-material/Payments";
import SavingsIcon from "@mui/icons-material/Savings";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import HealingIcon from "@mui/icons-material/Healing";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DnsOutlinedIcon from "@mui/icons-material/DnsOutlined";

export const ICON_MAP = {
  home: HomeIcon,
  church: ChurchIcon,
  listAlt: ListAltIcon,
  people: PeopleIcon,
  groups: GroupsIcon,
  search: SearchIcon,
  notifications: NotificationsIcon,
  message: MessageIcon,
  settings: SettingsIcon,
  article: ArticleIcon,
  label: LabelIcon,
  starBorder: StarBorderIcon,
  redeem: RedeemIcon,
  dashboardCustomize: DashboardCustomizeOutlinedIcon,
  groupWork: GroupWorkIcon,
  volunteerActivism: VolunteerActivismIcon,
  handshake: HandshakeIcon,
  insights: InsightsIcon,
  adminPanelSettings: AdminPanelSettingsIcon,
  event: EventIcon,
  eventAvailable: EventAvailableIcon,
  mail: MailIcon,
  personOutline: PersonOutlineIcon,
  personAdd: PersonAddIcon,
  trendingUp: TrendingUpIcon,
  campaign: CampaignIcon,
  send: SendIcon,
  payments: PaymentsIcon,
  savings: SavingsIcon,
  receiptLong: ReceiptLongIcon,
  healing: HealingIcon,
  addCircle: AddCircleOutlineIcon,
  dns: DnsOutlinedIcon,
};

export function getNavIcon(iconKey) {
  return ICON_MAP[iconKey] || HelpOutlineIcon;
}
